import {useEffect} from 'react';

import {useTranslation} from '/provider/TranslationProvider';

export const useClients = ({hasClientMetricsById, getClientMetrics}: any) => {
  const {tt} = useTranslation('screen.clients');

  useEffect(() => {
    // TODO move this API call somewhere else eventually -- prefetch data on login?
    if (!hasClientMetricsById) {
      getClientMetrics();
    }
  });

  return {tt};
};
